import { Tabs } from "@heroui/react";
import { useState, useEffect } from "react";

const TabsComp = ({ items = [], selectedKey, defaultKey, onChange }) => {
  const isControlled = selectedKey !== undefined;
  const [internal, setInternal] = useState(defaultKey || items[0]?.key);

  useEffect(() => {
    if (!isControlled && defaultKey) setInternal(defaultKey);
  }, [defaultKey, isControlled]);

  const currentKey = isControlled ? selectedKey : internal;

  const handleSelection = (key) => {
    const k = String(key);
    if (!isControlled) setInternal(k);
    onChange?.(k);
  };

  return (
    <Tabs
      selectedKey={currentKey}
      onSelectionChange={handleSelection}
      className="pointer-events-auto"
    >
      <Tabs.ListContainer className="bg-transparent">
        <Tabs.List
          aria-label="Navigation tabs"
          className="backdrop-blur-sm meetings-tab p-1 rounded-full tabs-list-shadow"
        >
          {items.map(({ key, title }) => (
            <Tabs.Tab key={key} id={key} className="text-muted text-xs data-[selected]:text-glass-foreground">
              {title}
              <Tabs.Indicator className="bg-accent" />
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs.ListContainer>
    </Tabs>
  );
};

export default TabsComp;